export const type = {
  areaList: [
    {
      key: 'BF',
      name: '北方区域'
    },
    {
      key: 'DB',
      name: '东北区域'
    },
    {
      key: 'ZN',
      name: '中南区域'
    },
    {
      key: 'HD',
      name: '华东区域'
    }
  ],
  terminalTypeList: [{
    label: '新中新',
    key: 'Synjones',
    list: [
      {
        code: 'app',
        label: '慧新易校APP',
        isCustomize: {
          flag: true,
          itemList: [{
            orderNumber: true,
            require: true,
            lable: '个性化单号'
          }, {
            appIcon: true,
            require: true,
            lable: '应用图标'
          }]
        }
      },
      {
        code: 'h5',
        label: '嵌入第三方'
      },
      {
        code: 'pc',
        label: '服务大厅'
      },
      {
        code: 'selfService',
        label: '自助终端'
      }
    ]
  }, {
    label: '腾讯',
    key: 'Tencent',
    list: [
      {
        code: 'weChatMiniProgram',
        label: '微信小程序',
        isAppid: {
          flag: true,
          require: true,
          label: 'AppID'
        },
        isHttps: true,
        modelName: 'weChatMiniProgram'
      },
      {
        code: 'weChatMiniMercacc',
        label: '微信小程序-商户版',
        isAppid: {
          flag: true,
          require: true,
          label: 'AppID'
        },
        isHttps: true,
        modelName: 'weChatMiniMercacc'
      },
      {
        code: 'wechat-mp',
        label: '微信公众号',
        isAppid: {
          flag: true,
          require: true,
          label: 'AppID'
        },
        modelName: 'wechatMp'
      },
      {
        code: 'wechat-work',
        label: '企业微信应用/微信企业号',
        isAppid: {
          flag: true,
          require: true,
          label: '企业ID/Corpid'
        },
        modelName: 'wechatWork'
      },
      {
        code: 'wechat-work-miniProgram',
        label: '企业微信小程序',
        isAppid: {
          flag: true,
          require: true,
          label: '企业ID/Corpid'
        },
        modelName: 'wechatWorkMiniProgram'
      }
    ]
  }, {
    label: '阿里',
    key: 'Alibaba',
    list: [
      {
        code: 'alipay-mina',
        label: '支付宝小程序',
        isAppid: {
          flag: true,
          require: false,
          label: 'AppID'
        },
        modelName: 'alipayMina',
        status: 1
      },
      {
        code: 'alipay-life',
        label: '支付宝生活号',
        isAppid: {
          flag: true,
          require: true,
          label: 'AppID'
        },
        modelName: 'alipayLife'
      },
      {
        code: 'alipay-WebMobile',
        label: '支付宝网页/移动应用',
        isAppid: {
          flag: true,
          require: true,
          label: 'AppID'
        },
        modelName: 'alipayWebMobile',
        status: 0
      },
      {
        code: 'dingtalkMiniProgram',
        label: '钉钉小程序',
        isAppid: {
          flag: true,
          require: true,
          label: 'AppID'
        },
        modelName: 'dingtalkMiniProgram',
        status: 0
      },
      {
        code: 'dingtalk',
        label: '钉钉应用',
        isAppid: {
          flag: true,
          require: true,
          label: 'AppID'
        },
        modelName: 'dingtalk'
      }
    ]
  }],
  terminalList: [
    {
      code: 'app',
      label: '慧新易校APP',
      isCustomize: {
        flag: true,
        itemList: [{
          orderNumber: true,
          require: true,
          lable: '个性化单号'
        }, {
          appIcon: true,
          require: true,
          lable: '应用图标'
        }]
      }
    },
    {
      code: 'weChatMiniProgram',
      label: '微信小程序',
      isAppid: {
        flag: true,
        require: true,
        label: 'AppID'
      },
      isHttps: true,
      modelName: 'weChatMiniProgram'
    },
    {
      code: 'weChatMiniMercacc',
      label: '微信小程序-商户版',
      isAppid: {
        flag: true,
        require: true,
        label: 'AppID'
      },
      isHttps: true,
      modelName: 'weChatMiniMercacc'
    },
    {
      code: 'wechat-mp',
      label: '微信公众号',
      isAppid: {
        flag: true,
        require: true,
        label: 'AppID'
      },
      modelName: 'wechatMp'
    },
    {
      code: 'wechat-work',
      label: '企业微信应用/微信企业号',
      isAppid: {
        flag: true,
        require: true,
        label: '企业ID/Corpid'
      },
      modelName: 'wechatWork'
    },
    {
      code: 'wechat-work',
      label: '企业微信小程序',
      isAppid: {
        flag: true,
        require: true,
        label: '企业ID/Corpid'
      },
      modelName: 'wechatWork'
    },
    {
      code: 'h5',
      label: '嵌入第三方'
    },
    {
      code: 'pc',
      label: '服务大厅'
    },
    {
      code: 'selfService',
      label: '自助终端'
    },
    {
      code: 'alipay-life',
      label: '支付宝生活号',
      isAppid: {
        flag: true,
        require: true,
        label: '应用ID'
      },
      modelName: 'alipayLife'
    },
    {
      code: 'alipay-WebMobile',
      label: '支付宝网页/移动应用',
      isAppid: {
        flag: true,
        require: true,
        label: '应用ID'
      },
      modelName: 'alipayWebMobile',
      status: 0
    },
    {
      code: 'alipay-mina',
      label: '支付宝小程序',
      isAppid: {
        flag: true,
        require: true,
        label: '应用ID'
      },
      modelName: 'alipayMina',
      status: 0
    },
    {
      code: 'dingtalkMiniProgram',
      label: '钉钉小程序',
      isAppid: {
        flag: true,
        require: true,
        label: '应用ID'
      },
      modelName: 'dingtalkMiniProgram',
      status: 0
    },
    {
      code: 'dingtalk',
      label: '钉钉应用',
      isAppid: {
        flag: true,
        require: true,
        label: '应用ID'
      },
      modelName: 'dingtalk'
    }
  ]
}
